import { Flex, Text, TypeColors } from '@bitrise/bitkit';
import { SeriesPointXY } from '@bitrise/bitviz';
import React, { FunctionComponent } from 'react';
import { DurationUnit } from 'luxon';
import BuildSeriesKey from './BuildSeriesKey';
import getFormattedValue from '../../../utils/metric/getFormattedValue';
import getTimeRangeString from '../getTimeRangeString';

type Props = {
  seriesAvgMax: [SeriesPointXY[], SeriesPointXY[]];
  seriesBranchOther: [SeriesPointXY[], SeriesPointXY[]];
  step: DurationUnit;
  stepSize: number;
  timestamp: number;
  x: number;
};

const BuildTimeOverTimeTooltipContent: FunctionComponent<Props> = ({
  seriesAvgMax,
  seriesBranchOther,
  step,
  stepSize,
  timestamp,
  x,
}) => {
  const keys: [string, TypeColors, SeriesPointXY[]][] = [
    ['Average', 'yellow-4', seriesAvgMax[0]],
    ['Max', 'grape-2', seriesAvgMax[1]],
  ];

  if (seriesBranchOther[0].length) {
    keys.push(
      ['Default branch', 'aqua-3', seriesBranchOther[0]],
      ['Others', 'grape-5', seriesBranchOther[1]],
    );
  }

  return (
    <Flex>
      <Text config="9" align="middle" margin="x2">
        {getTimeRangeString(timestamp, step, stepSize)}
      </Text>

      {keys.map(([title, color, data]) => (
        <BuildSeriesKey color={color} key={title} margin="x1">
          <Flex direction="horizontal" gap="x2">
            <Flex grow>
              <Text config="8" weight="bold">
                {title}
              </Text>
            </Flex>
            <Flex>
              <Text align="end" config="8">
                {getFormattedValue('seconds', data[x] && data[x].y)}
              </Text>
            </Flex>
          </Flex>
        </BuildSeriesKey>
      ))}
    </Flex>
  );
};

export default BuildTimeOverTimeTooltipContent;
